import { HttpClient, HttpHeaders } from "@angular/common/http";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { Observable, throwError } from "rxjs";
import { catchError, pluck, tap } from "rxjs/operators";
import { DefinedCardPaymentInfo, TransactionRequestCardOpTypes, TransactionRequestPaymentModels, TransactionRequestPayWDefinedCardResponseModel, TransactionRequestResponseModels, TranscationRequestSaveCardResponseModel } from "src/app/card-operations-core/models/transaction-request-models";
import { AppConfig } from "src/app/config-service/app.config";
import { VersionHelper } from "src/app/utility-packages/versionHelper/version-helper";

export class TransactionRequestResponseCreator{
    constructor(
        private http:HttpClient,
        private versionHelper: VersionHelper,
        private translate: TranslateService,
        private toastr: ToastrService
    ){}

    createResponseReturnPaymentInfo = (headers:HttpHeaders, body:URLSearchParams) 
      : Observable<TransactionRequestPaymentModels> => 
      {
        return this.http
        .post<TransactionRequestResponseModels>(
          AppConfig.settings.apiServer.url + 'api/transaction/request', body.toString(),
          {
            headers: headers,
            responseType: 'json',
            params: {
              region: AppConfig.settings.city.region,
              lang: AppConfig.settings.apiServer.lang,
              authType: AppConfig.settings.apiServer.authType,
              version: this.versionHelper.getVersion(),
            },
          }
        )
        .pipe(
          tap(response => {
            if(response.result.code !== 0){
              this.toastr.error(response.result.message)
            }
          }),
          catchError((error) => {
            if (typeof error === 'string') {
              throwError(error);
            } else {
              throwError(
                this.translate.instant('DEFAULT_ERROR_MESSAGE')
              );
            }
            throw new Error(error);
          }),
          pluck('paymentInfo')
        );
    }
}